export default {
	label: 'Module | Modules',
	related: 'Related module',
	responsiblesForAssets: 'Module responsibles for assets',
	responsibleInfoTooltip:
		'If an asset within the module requires a different responsible person, you can assign one for each asset associated with the module through the "Module responsibles for assets" list.',
	noConnectedAssets: 'No connected assets',
	connectAssetHint: 'Connect an asset to the module',
	associationName: 'Association name',
	overwriteText: 'Do you want to overwrite the measures responsibles with the selected module responsible?',
	replaceText:
		'When the "Replace unassigned" button is clicked, responsibles will only be assigned to measures without an existing responsible.',
	replaceUnassigned: 'Replace unassigned',
	replaceAll: 'Replace all',
	type: 'Type',
	systemModule: 'System module',
	processModule: 'Process module',
	addModule: 'Add module',
	editModule: 'Edit module',
	status: {
		label: 'Status',
		applicable: 'Applicable',
		inapplicable: 'Inapplicable',
		excluded: 'Excluded',
	},
	search: 'Search module',
	stats: 'Method statuses',
}
